/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../table/entity-table.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function UserRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.users', {
            url: '/users',
            module: 'private',
            auth: types.allAuthorities, //types.adminAuthorities,
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'user.users'
            },
            ncyBreadcrumb: {
                label: '{"icon": "account_circle", "label": "{{ vm.entityTableConfiguration.tableTitle }}", "translate": "false"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                function($stateParams, userTableConfig) {
                     return userTableConfig.getConfig($stateParams);
                }
            }
        })
        .state('home.providers.users', {
            url: '/:providerId/users',
            module: 'private',
            auth: [types.authority.SYS_ADMIN.value, types.authority.SYS_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'user.provider-users'
            },
            ncyBreadcrumb: {
                label: '{"icon": "account_circle", "label": "{{ vm.entityTableConfiguration.tableTitle }}", "translate": "false"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, userTableConfig) {
                        return userTableConfig.getConfig($stateParams);
                    }
            }
        }).state('home.customers.users', {
            url: '/:customerId/users',
            module: 'private',
            auth: [types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'user.customer-users'
            },
            ncyBreadcrumb: {
                label: '{"icon": "account_circle", "label": "{{ vm.entityTableConfiguration.tableTitle }}", "translate": "false"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, userTableConfig) {
                        return userTableConfig.getConfig($stateParams);
                    }
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/user/user.routes.js